import type { QuoteSource } from "../types/shipping-quotes-api.types";
import { CURRENCY_OPTIONS } from "../../confirmations/constants/currencies.config";

export const SHIPPING_QUOTES_API_PATH = "internal/shipping-quotes";

export const QUOTER_HISTORY_PAGE_SIZE = 10;

export const PAGINATION_SIZES = [10, 25, 50] as const;

export const QUOTE_SOURCE_LABELS: Record<QuoteSource, string> = {
  web: "Web",
  app: "App",
  api: "API",
  internal: "Interno",
  manual: "Manual",
};

export const QUOTER_HISTORY_CURRENCY_OPTIONS: { value: string; label: string }[] =
  CURRENCY_OPTIONS.map((opt) => ({ value: opt.value, label: opt.label }));

export const CURRENCY_TO_COUNTRY_NAME: Record<string, string> = {
  BRL: "Brasil",
  COP: "Colombia",
  USD: "Estados Unidos",
  MXN: "México",
  EUR: "Unión Europea",
  PEN: "Perú",
  CLP: "Chile",
  GBP: "Reino Unido",
};
